const toFiniteNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const padDatePart = (value) => String(value).padStart(2, "0");

export const formatLocalDateInput = (date = new Date()) =>
  `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(
    date.getDate(),
  )}`;

export const applyReportDateScope = (
  filters = {},
  scope,
  date = new Date(),
) => {
  const today = formatLocalDateInput(date);
  return {
    ...filters,
    search: "",
    dateFrom: scope === "all" ? "" : today,
    dateTo: scope === "all" ? "" : today,
  };
};

export const filterReportTransactions = (transactions = [], filters = {}) =>
  transactions.filter((transaction) => {
    const search = filters.search || "";
    const matchesSearch =
      !search ||
      transaction.transaction_id.toLowerCase().includes(search.toLowerCase());
    const transactionDate = new Date(transaction.created_at);
    const matchesDateFrom =
      !filters.dateFrom ||
      transactionDate >= new Date(`${filters.dateFrom}T00:00:00`);
    const matchesDateTo =
      !filters.dateTo ||
      transactionDate <= new Date(`${filters.dateTo}T23:59:59.999`);

    return matchesSearch && matchesDateFrom && matchesDateTo;
  });

export const getVisibleReportTransactions = (
  transactions = [],
  page = 1,
  pageSize = 10,
) => transactions.slice((page - 1) * pageSize, page * pageSize);

export const calculateReportSummary = (transactions = []) => {
  const totals = transactions.reduce(
    (summary, transaction) => ({
      revenue: summary.revenue + toFiniteNumber(transaction.total_amount),
      itemsSold: summary.itemsSold + toFiniteNumber(transaction.item_count),
    }),
    { revenue: 0, itemsSold: 0 },
  );

  const transactionCount = transactions.length;

  return {
    transactionCount,
    revenue: totals.revenue,
    averageSale: transactionCount ? totals.revenue / transactionCount : 0,
    itemsSold: totals.itemsSold,
  };
};
